define('shared/initializer/form/newHouseAdapters/mixins/MemberEventTrackable',[ 
    '../../constants', 
    'shared/lib/RSVP',
    'shared/util/tracking/dailyLesson',
    'shared/util/tracking/pendingEvents',
    'shared/util/state',
    './SubscriptionsSavable',
    'shared/util/checkout/member',
],
function ( 
    constants, 
    RSVP, 
    dailyLessonUtil,
    pendingEventsUtil,
    state,
    SubscriptionsSavable,
    memberUtil
) {
    'use strict';

    function Ctor(){}

    var p = Ctor.prototype;

    p.doBeforeRedirect = function(data){
        if(memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve()
                .then(function() {
                    return data;
                });
        }

        return RSVP.resolve()
            .then(function() {
                return pendingEventsUtil.add(constants.EVENT.MemberRegistration);
            })
            .then(function(){
                return state.get(SubscriptionsSavable.STATE_KEY);
            })
            .then(function(values){
                var subscriptions = values[0];
                if(subscriptions.emailEnglish){
                    return pendingEventsUtil.add(constants.EVENT.EmailEnglish);
                }
                else{
                    return RSVP.resolve();
                }
            })
            .then(function(){
                return data;
            });
    };

    return Ctor;
});
